import script from "./PhotoGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&setup=true&lang=js"

import "./PhotoGallery.vue?vue&type=style&index=0&id=b47d9ec6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b47d9ec6"]])

export default __exports__